export default "__VITE_PUBLIC_ASSET__fb33d723__"